import styled from 'styled-components';
import { BackdropProps, ModalContainerProps } from '../@types/modal';

const DEFAULT_Z_INDEX = 1000;

export const Backdrop = styled.div<BackdropProps>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    display: flex;
    justify-content: center;
    align-items: center;
    
    z-index: ${({ zIndex }) => zIndex};
    background-color: ${({ color }) => color};
    backdrop-filter: blur(${({ blur }) => blur});
`;

Backdrop.defaultProps = {
    zIndex: DEFAULT_Z_INDEX,
    color: '#EEEA',
    blur: '4px',
};

export const ModalContainer = styled.div<ModalContainerProps>`
    ${({ width }) => width && `width: ${width};`}
    z-index: ${({ zIndex }) => zIndex || DEFAULT_Z_INDEX + 10};
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
`;


